<template>
  <section class="historico">
    <div v-for="(item, index) in historico" :key="index">
      {{ item.usuario + ", " + item.email + ", " + item.acao + ", " + item.nome }}
    </div>
  </section>
</template>

<script>
export default {
  props: ['historico']
}
</script>



// WEBPACK FOOTER //
// HistoricoNotificacoes.vue?43e5dc32